import React from 'react';
import injectSheet from 'react-jss';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Switch from 'material-ui/Switch';
import { createMuiTheme, MuiThemeProvider } from 'material-ui/styles';

// A local theme is created due to collisions between our generated theme file and the one materialUI expects.
// So I'm creating a new theme instance, based on materialUI's defaults.
const theme = createMuiTheme();

const _Switch = ({classes, onChange, toggleOn}) => {
    return (
        <div className={classes.switchWrap}>
            <MuiThemeProvider theme={theme}>
                <FormGroup row>
                    <FormControlLabel
                        className={classes.label}
                        control={
                            <Switch
                                checked={toggleOn}
                                onChange={onChange}
                                classes={{
                                    checked: classes.checked,
                                    bar: classes.bar,
                                }}
                            />
                        }
                    />
                </FormGroup>
                <span className={classes.bots}>BOTS</span>
            </MuiThemeProvider>
        </div>
    );
};
const styles = theme => ( {
    switchWrap: {
        position: 'absolute',
        right: 0,
        bottom: '-6px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    label: {
        margin: 0
    },
    bots: {
        fontSize: '9px',
        fontWeight: '500',
        color: '#a9a9a9',
        backgroundColor: 'white',
        padding: '0 6px'
    },
    checked: {
        color: '#02bfe1',
        '& + $bar': {
            backgroundColor: '#5ab4c4',
        },
    },
    bar: {},
} );

export default injectSheet(styles)(_Switch);



// WEBPACK FOOTER //
// ./src/app/components/switch/Switch.js